import { OverlayOptions } from 'primeng/api';

export const DIALOG_EVENT_OVERLAY_Z_CLASS = '!z-app-overlay-0';

export const DIALOG_EVENT_OVERLAY_OPTIONS: OverlayOptions = {
  appendTo: 'body',
  autoZIndex: false,
  styleClass: DIALOG_EVENT_OVERLAY_Z_CLASS,
};
